import type { BulkOperationType } from '../../types';

export const DEFAULT_BUTTON_TEXTS: Partial<
  Record<BulkOperationType, string>
> & {
  allocate: string;
} = {
  edit: 'Edit Allocations',
  discard: 'Discard Allocations',
  publish: 'Publish Allocations',
  allocate: 'Allocate'
};

export const DEFAULT_DROPDOWN_TEXT = 'Bulk Operations';
export const DROPDOWN_TRIGGER:
  ('click' | 'hover' | 'contextMenu')[] | undefined = ['click'];
